import { msg } from '@lingui/core/macro'
import { createFileRoute } from '@tanstack/react-router'
import { ProposalListView } from '~/components/funnel/proposal-list-view'
import { PROPOSAL_VIEWS, type ProposalView } from '~/lib/proposal-views'
import { titleFor } from '~/lib/route-title'
import { optionalString } from '~/lib/search-params'

export type ProposalsSearch = {
  /** Selected view; absent is treated as the default `'list'`. */
  view?: ProposalView
  /** Full-text search query (matches project name, number, stage label). */
  q?: string
}

const proposalView = (raw: unknown): ProposalView | undefined =>
  PROPOSAL_VIEWS.find((value) => value === raw)

export const Route = createFileRoute('/_authenticated/$workspaceSlug/documents/')({
  component: ProposalListRoute,
  head: () => ({ meta: [{ title: titleFor(msg`Proposals`) }] }),
  validateSearch: (search: Record<string, unknown>): ProposalsSearch => ({
    q: optionalString(search.q),
    view: proposalView(search.view),
  }),
})

function ProposalListRoute() {
  return <ProposalListView />
}
